import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const MoreHorizontal24 = (props: SvgIconProps): JSX.Element => React.createElement(SvgIcon, props, <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path fillRule='evenodd' clipRule='evenodd' d='M5 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm5 2a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm7 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z' /></svg>);
